__turbopack_context__.v({
  "button": "CatalogLoadMore-module__Tkk1BG__button",
  "info": "CatalogLoadMore-module__Tkk1BG__info",
  "wrap": "CatalogLoadMore-module__Tkk1BG__wrap",
});
